<template>
  <div>
    <b-row>
      <b-col>
        <b-card class="mb-2">
          <b-row>
            <b-col cols="10" class="h3 mb-1">
              <span variant="primary">Configuración de Aulas</span>
            </b-col>
            <b-col>
              <b-button variant="primary" class="m-1">
                <b-iconstack font-scale="1" class="ml-1" title="Agregar">
                  <b-icon stacked icon="plus" shift-h="-11"></b-icon>
                  <b-icon stacked icon="door-open-fill"></b-icon>
                </b-iconstack>
                <span class="ml-3">Agregar Aula</span>
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <loading :active="isLoading" :is-full-page="true"></loading>
      <b-col>
        <b-card title="Listado de Aulas">
          <b-table class="mt-2 text-center" sticky-header no-border-collapse head-variant="light"
            style="min-height: 60vh;" striped :items="items" :fields="roomsFields" responsive>
            <template #cell(display_name)="data" v-if="!isLoading">
              <div v-if="edit[data.index]">
                <b-input v-model="data.item.display_name">asd</b-input>
              </div>
              <div v-else>
                {{ data.item.display_name }}
              </div>
            </template>
            <template #cell(x_capacity)="data" v-if="!isLoading">
              <div v-if="edit[data.index]">
                <b-input v-model="data.item.x_capacity">asd</b-input>
              </div>
              <div v-else>
                {{ data.item.x_capacity }}
              </div>
            </template>
            <template #cell(x_type)="data" v-if="!isLoading">
              <div v-if="edit[data.index]">
                <b-form-select v-model="data.item.x_type" :options="options"></b-form-select>
              </div>
              <div v-else>
                {{ data.item.x_type === "virtual" ? "Virtual" : "Presencial" }}
              </div>
            </template>
            <template #cell(actions)="data">
              <b-icon @click='guardar(data.item, data.index)' v-if="edit[data.index]" icon=check-lg
                class="h2 mb-1 px-1 btn-like-icon" hover v-b-tooltip.hover title="Guardar" variant="success"></b-icon>
              <b-icon @click='cancelar(data.index)' v-if="edit[data.index]" icon=x-lg
                class="h2 mb-1 ml-2 px-1 btn-like-icon" hover v-b-tooltip.hover title="Cancelar"
                variant="danger"></b-icon>
              <b-icon @click='editar(data.index)' v-if="!edit[data.index]" icon=pencil-square
                class="h2 mb-1 px-1 btn-like-icon" hover v-b-tooltip.hover title="Editar" variant="primary"></b-icon>
              <b-icon @click='borrar(data.item.id)' v-if="!edit[data.index]" icon=archive-fill
                class="h2 mb-1 ml-2 px-1 btn-like-icon" hover v-b-tooltip.hover title="Archivar"
                variant="primary"></b-icon>
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { RoomService } from '@/services/room.service'
import Loading from 'vue-loading-overlay'

export default {
  name: 'Rooms',
  data () {
    return {
      isLoading: true,
      edit: {},
      items: [],
      options: [
        { value: 'physical', text: 'Presencial' },
        { value: 'virtual', text: 'Virtual' }
      ],
      roomsFields: [
        { key: 'display_name', label: 'Nombre', thStyle: { width: '25%' } },
        { key: 'x_capacity', label: 'Capacidad', thStyle: { width: '25%' } },
        { key: 'x_type', label: 'Tipo de Aula', thStyle: { width: '25%' } },
        { key: 'actions', label: 'Acciones', thStyle: { width: '25%' } }
      ]
    }
  },
  components: {
    Loading
  },
  watch: {

  },
  computed: {

  },
  async created () {
    this.isLoading = true
    await this.updateLista()
    this.isLoading = false
  },
  methods: {
    updateLista: async function () {
      try {
        this.items = await RoomService.list()
        // console.log('aulas ', this.items)
      } catch (error) {
        console.log(error)
      }
    },
    // agregar () {
    //   this.isLoading = true
    //   this.items.push({
    //     x_name: '',
    //     x_project_id: this.projectId
    //   })
    //   this.edit[this.items.length - 1] = true
    //   this.isLoading = false
    // },
    cancelar (index) {
      // console.log(this.edit, 'edit')
      this.isLoading = true
      if (!this.items[index].id) {
        this.items.splice(index, 1)
      } else {
        // console.log(this.edit[index], 'arriba')
        this.edit[index] = false
        // console.log(this.edit[index], 'abajo')
      }
      this.isLoading = false
    },
    async guardar (item, index) {
      this.isLoading = true
      if (item.id) {
        const updateItem = {
          display_name: item.display_name,
          x_capacity: item.x_capacity,
          x_type: item.x_type
        }
        console.log(updateItem)
        await RoomService.update([item.id], updateItem)
        // await this.updateAccountMoves(item)
      } else {
        this.itemsGroups[index].id = await RoomService.create(item)
      }
      this.edit[index] = false
      this.isLoading = false
    },
    async editar (index) {
      if (Object.keys(this.edit)[0] !== index && Object.keys(this.edit)[0] !== undefined) {
        delete this.edit[Object.keys(this.edit)[0]]
      }
      this.isLoading = true
      this.edit[index] = true

      this.isLoading = false
    },
    async borrar (id) {
      this.isLoading = true
      try {
        await RoomService.delete(id)
      } catch (error) {
        this.toastMessage = 'XXX'
        console.log(error)
        this.$bvToast.toast('ERROR', {
          title: 'ERROR'
        })
      }

      await this.updateLista()
      this.isLoading = false
    }
  }
}
</script>

<style lang="scss" scoped></style>
